import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

import { ApiCommonService } from 'cbc-shared-lib';

import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

import {
  Sgkd016aService,
  Sgkd016aRequest,
  Sgkd016aResponse
} from 'sg-api';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkd004dSgkd016aService {

  private _rsesult$ = new Subject<Sgkd016aResponse>();

  constructor(
    private sgkd016aService: Sgkd016aService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 口座振替・クレジット申込書一括印刷検索API呼び出し
   * @param company 受付拠点（会社）
   * @param sosiki 受付拠点（組織）
   * @param from 受付年月日(From)
   * @param to 受付年月日(To)
   * @param srndocClscode 申込書種別コード
   * @param srndocDeliveryStatuscode 申込書送付ステータス
   * @memberof UsedSgkd04dSgkd016aService
   */
  select(company: string, sosiki: string, from: string, to: string,
         srndocClscode: string, srndocDeliveryStatuscode: string): Observable<Sgkd016aResponse> {

    // リクエスト生成
    let request: Sgkd016aRequest = {
      requestDto: {
        /** 受付拠点（会社） */
        acceptbaseCompany: company,
        /** 受付拠点（組織） */
        acceptbaseSosiki: sosiki,
        /** 受付年月日(From) */
        aceptYearmonthdateFrom: from,
        /** 受付年月日(To) */
        aceptYearmonthdateTo: to,
        /** 申込書種別コード */
        srndocClscode: srndocClscode,
        /** 申込書送付ステータス */
        srndocDeliverySts: srndocDeliveryStatuscode
      }
    };

    return this.sgkd016aService.doSGKD016APost(this.apiCommonService.setRequestCommon(request), 'response')
      // NOTE:component側に戻り値として値を返却したい場合は、pipe(map())処理内で値を返却する。
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          this._rsesult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKD016A');
          return throwError(err.message);
        }
      )
    );
  }
}
